import { crmRequest } from '../http'
import type {
  ConsentChannel,
  ConsentStatus,
  CrmContactCardScan,
  CrmContactDetail,
  CrmContactUpdate,
} from '../types'

// The contact page reads its answers through `crmRequest`: a failure arrives with the
// backend's Dutch message, and a 404 can be told apart (`CrmApiError.status`).

/** A merged contact answers with where it went (spec-68). */
export function getContactRecord(personId: string): Promise<CrmContactDetail | { moved_to: string }> {
  return crmRequest(`/contacts/${personId}`)
}

export function patchContact(personId: string, patch: CrmContactUpdate): Promise<CrmContactDetail> {
  return crmRequest(`/contacts/${personId}`, { method: 'PATCH', body: JSON.stringify(patch) })
}

export function putContactLabels(personId: string, labelIds: string[]): Promise<CrmContactDetail> {
  return crmRequest(`/contacts/${personId}/labels`, {
    method: 'PUT',
    body: JSON.stringify({ label_ids: labelIds }),
  })
}

export function putConsent(
  personId: string,
  input: { channel: ConsentChannel; status: ConsentStatus; source?: string },
): Promise<CrmContactDetail> {
  return crmRequest(`/contacts/${personId}/consents`, {
    method: 'PUT',
    body: JSON.stringify(input),
  })
}

export function getCardScans(personId: string): Promise<CrmContactCardScan[]> {
  return crmRequest(`/contacts/${personId}/card-scans`)
}

/** The one delete there is for a contact: the bulk route, for this one person. */
export function deleteContact(personId: string): Promise<{ updated: number }> {
  return crmRequest('/contacts/bulk/delete', {
    method: 'POST',
    body: JSON.stringify({ person_ids: [personId] }),
  })
}
